import React from 'react';
import { Helmet } from 'react-helmet';
import { connect, MapStateToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { appDispatch, IAppInstance, RootState } from 'store/store';
import messages from './Messages';
import { display } from 'components/ErrorView/ErrorDialog';
import protectedRoute from 'components/protectedRoute';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import {
  IProviderTemplates,
  requireAllTemplates,
} from 'store/templates/templatesSlice';
import { IProviders } from 'store/providers/providerTypes';

type ParamsProps = {
  providerId: string;
};
type OwnProps = RouteComponentProps<ParamsProps>;
type OtherTypes = {
  children: React.ReactNode;
};
type StateToProps = {
  templates: IProviderTemplates;
  appInstance: IAppInstance;
  thisProvider: IProviders['map'][0] | null;
};

type ComponentProps = OwnProps & StateToProps & OtherTypes;

class ProviderTemplateContainer extends React.Component<ComponentProps> {
  componentDidMount() {
    appDispatch(
      requireAllTemplates({ appInstanceId: this.props.appInstance.id! })
    ).catch((err: any) => {
      display(err);
    });
  }

  render() {
    const { children, templates, thisProvider } = this.props;
    if (
      !thisProvider ||
      thisProvider?.isLoading ||
      templates.state !== 'loaded'
    ) {
      return <LoadingIndicator />;
    }

    return (
      <div>
        <Helmet>
          <title>{messages.templates}</title>
          <meta name="description" content={messages.templates} />
        </Helmet>
        {children}
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state,
  props
) => {
  const appInstance = state.appInstance;
  const thisProviderId = props.providerId ? Number(props.providerId) : null;
  const thisProvider = thisProviderId
    ? state.providers.map[thisProviderId]
    : null;
  const templates = state.templates;

  return { thisProvider, appInstance, templates };
};

export default protectedRoute(
  connect(mapStateToProps)(ProviderTemplateContainer)
);
